import { Button, Divider, Empty, IconFont, Text } from '@byecode/ui'
import { timeDistance, TooltipText } from '@lighthouse/shared'
import React, { useMemo } from 'react'
import styled from 'styled-components'

import { WxProgramsAuditStatus } from '@/services/types'
import { useWxMiniProgramsAuthorizationResult } from '@/shared/reusable'

const SCxContainer = styled.div`
    width: 100%;
    /* margin-top: 20px; */
    overflow: hidden;
    border-radius: 6px;
    border: 1px solid var(--color-gray-200);
`
const SCxContent = styled.div`
    width: 100%;
    padding: 13px 12px;
    display: flex;
    flex-direction: column;
    gap: 9px;
`
const SCxTitle = styled.div`
    height: 36px;
    line-height: 36px;
    background-color: var(--color-gray-100);
    color: var(--color-gray-600);
    text-align: center;
    font-size: var(--font-size-normal);
`

const SCxPassedTitle = styled.div`
    height: 36px;
    line-height: 36px;
    background-color: var(--color-gray-50);
    color: var(--color-gray-500);
    text-align: center;
    font-size: var(--font-size-normal);
`

const SCxItem = styled.div`
    display: flex;
    align-items: center;
    gap: 24px;
    height: 20px;
`
const SCxLeftFill = styled.div`
    width: 56px;
    font-size: var(--font-size-sm);
    color: var(--color-gray-400);
    flex-shrink: 0;
`

const SCxRightFill = styled(Text)`
    color: var(--color-gray-600);
    font-size: var(--font-size-sm);
`

interface AuditInfoProps {
    onRedo?: () => void
}

const AuditInfo: React.FunctionComponent<AuditInfoProps> = ({ onRedo }) => {
    const { data: wxMiniProgramsAuthorization } = useWxMiniProgramsAuthorizationResult()
    const { auditInfo } = wxMiniProgramsAuthorization || {}

    return (
        <SCxContainer>
            {auditInfo?.status === WxProgramsAuditStatus.AUDITING && <SCxTitle>微信侧审核中，约1-7个工作日</SCxTitle>}
            {auditInfo?.status === WxProgramsAuditStatus.PASSED && <SCxPassedTitle>审核已通过</SCxPassedTitle>}
            <SCxContent>
                {/* <SCxItem>
                    <SCxLeftFill>版本号</SCxLeftFill>
                    <SCxRightFill>{auditInfo?.version}</SCxRightFill>
                </SCxItem> */}
                <SCxItem>
                    <SCxLeftFill>提审时间</SCxLeftFill>
                    <SCxRightFill>{timeDistance(auditInfo?.auditCreateTime ?? Date.now())}</SCxRightFill>
                </SCxItem>
                <SCxItem>
                    <SCxLeftFill>版本描述</SCxLeftFill>
                    <TooltipText
                        title={auditInfo?.description}
                        render={ref => <SCxRightFill ref={ref}>{auditInfo?.description}</SCxRightFill>}
                    />
                </SCxItem>

                <Button
                    style={{
                        marginTop: 8
                    }}
                    type="default"
                    size="lg"
                    block
                    onClick={onRedo}
                >
                    撤销
                </Button>
            </SCxContent>
        </SCxContainer>
    )
}

export default AuditInfo
